import { render, staticRenderFns } from "./bsp-table-column.vue?vue&type=template&id=4b8ed401&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./bsp-table-column.vue?vue&type=script&lang=js&"
export * from "./bsp-table-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8ed401",
  null
  
)

export default component.exports